import { SupportedLocaleEnum } from '@reward-platform/platform-config'
import { createPathname } from '@reward-platform/utils'
import { normalisePathname } from './normalisePathname'

const ROOT_PATH = '/'

const UNRESTRICTED_PRODUCT_PATHS = ['hotels', 'cars']
const UNRESTRICTED_ROOT_TABS = ['hotels', 'carhire']

export const buildUnrestrictedRootPaths = (basePath?: string, locale?: string): string[] => {
  const isSupportedLocale = SupportedLocaleEnum.safeParse(locale).success
  const localisedRootPath = isSupportedLocale
    ? createPathname(ROOT_PATH, basePath, locale)
    : createPathname(ROOT_PATH, basePath)

  const rootPaths = [ROOT_PATH, basePath, localisedRootPath].filter(
    (path): path is string => !!path
  )

  return Array.from(new Set(rootPaths))
}

export const isAuthRequiredForPath = (
  path?: string,
  unrestrictedRootPaths: string[] = [ROOT_PATH]
): boolean => {
  if (!path || path === ROOT_PATH || path === '') {
    return false
  }

  const [pathWithoutHash] = path.split('#')
  const [rawPathname, search = ''] = pathWithoutHash.split('?')
  const pathname = normalisePathname(rawPathname)
  const pathSegments = pathname.split('/').filter(Boolean)
  const tab = new URLSearchParams(search).get('tab')
  const isRootPath = unrestrictedRootPaths.some(
    (rootPath) => normalisePathname(rootPath) === pathname
  )

  if (isRootPath && tab && UNRESTRICTED_ROOT_TABS.includes(tab)) {
    return false
  }

  return !UNRESTRICTED_PRODUCT_PATHS.some((product) => pathSegments.includes(product))
}
